import { Suspense } from "react";
import { createRoot } from "react-dom/client";

import "react-app-polyfill/stable";
import "antd/dist/antd.css";
import "swiper/css";
import "swiper/css/navigation";
import "./assets/fonts/main.css";
import "./index.css";
import LoadingScreen from "./components/LoadingScreen";
import Providers from "./providers";
import { lazyWithRetry } from "./utils/componentLoader";

const App = lazyWithRetry(() => import("./App"));

const domNode = document.getElementById("root");

if (domNode) {
  const root = createRoot(domNode);
  root.render(
    <Providers>
      <Suspense fallback={<LoadingScreen />}>
        <App />
      </Suspense>
    </Providers>
  );
}
